import styled from "styled-components";

export const LookingForListingWrapper = styled.div`
  display: flex;
  width: 100%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  background-color: var(--white);
  border-radius: 10px;
  padding: 24px;
  flex-wrap: wrap;
  .propertiesGridWrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /* gap: 16px; */
    width: 100%;
    .colPropertiesGrid {
      margin-bottom: 10px;
      border: 1px solid var(--border);
      border-radius: 10px;
      padding: 16px;
      display: block;

      .contact-btn {
        padding: 5px 10px;
        border: 2px solid var(--themeColorSecondary);
        border-radius: 10px;
      }

      .propertyImgWrapper {
        width: 100%;
        display: block;
        position: relative;
        /* .propertyImage{
                    width: 100%;
                    display: flex;
                    border-radius: 16px 16px 0 0px;
                    overflow: hidden;
                    & img{
                        display: block;
                        width: 100%;
                    }
                    
                }     */
        .swiper-slide {
          /* border-radius: 16px 16px 0 0px; */
          overflow: hidden;
          .slide-content {
            /* border-radius: 16px 16px 0 0px; */
            overflow: hidden;
            img {
              height: 180px;
              border-radius: 16px 16px 0 0px;
              overflow: hidden;
            }
          }
        }

        .propertyStatus {
          position: absolute;
          z-index: 99;
          top: 16px;
          right: 16px;
          padding: 6px 16px 4px 16px;
          border-radius: 6px;
          text-transform: uppercase;
          line-height: 1;
          body.rtl & {
            right: auto;
            left: 16px;
          }
        }
      }
      .titleLocationWrapper {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding: 16px 0 0 0;
        .titleLocation {
          /* display: flex; */
          width: 100%;
          /* flex-direction: column; */
        }
        .price-wrapper {
          margin-right: 15px;
          body.rtl & {
            margin-right: 0;
            margin-left: 15px;
          }
        }
        .propertyActionDropdown {
          position: absolute;
          right: 0;
          top: 20px;
          .dropdown-toggle {
            flex-direction: row-reverse;
          }
          body.rtl & {
            right: auto;
            left: 0;
          }
        }
      }
      .peopleLocationRole {
        display: flex;
        align-items: center;
        padding-bottom: 16px;
        border-bottom: 1px solid var(--border);
        & span:first-child {
          position: relative;
          padding-right: 12px;
          margin-right: 12px;
          /* &::after {
            content: "";
            height: 13px;
            width: 1px;
            background-color: var(--lightGrey);
            position: absolute;
            right: 0;
            top: auto;
            bottom: auto;
          } */
        }
        body.rtl & span:first-child {
          padding-right: 0;
          padding-left: 12px;
          margin-right: 0;
          margin-left: 12px;
          &::after {
            right: auto;
            left: 0;
          }
        }
      }
      .advIdentityWrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        width: 100%;
        padding-top: 14px;
        span {
          text-wrap: nowrap;
        }
      }
    }
  }
  @media (max-width: 991px) {
    .propertiesGridWrapper {
      /* gap: 8px; */
      .colPropertiesGrid {
        /* padding: 0; */
        .swiper-slide {
          .slide-content {
            img {
              border-radius: 10px 10px 0 0px !important;
            }
          }
        }
        .titleLocationWrapper {
          padding-left: 8px;
          padding-right: 8px;
        }
        .advIdentityWrapper {
          gap: 10px;
          flex-wrap: wrap;
          justify-content: space-between;
          padding-left: 8px;
          padding-right: 8px;
          padding-bottom: 8px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    box-shadow: none;
    border-radius: 0px;
    padding: 16px;
    .propertiesGridWrapper {
      display: flex;
      overflow-x: auto;
      & > div {
        min-width: 260px;
      }
      .colPropertiesGrid {
        padding: 10px;
        .propertyImgWrapper {
          img {
            height: 111px !important;
          }
        }
        .titleLocationWrapper {
          padding-top: 3px;
          padding-bottom: 3px;
          flex-wrap: wrap;
          .budget-box{
            align-items: center!important;
          }
          .budget-heading{
            font-size: 16px;
          }
          .propertyActionDropdown {
            top: 10px;
          }
        }
        /* .advIdentityWrapper {
          justify-content: space-between;
        } */
      }
    }
  }
`;
